export { VpClipChip } from './VpClipChip';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpClipChip/index.js